  import React, { useState } from "react";
  import { useNavigate, useSearchParams } from "react-router-dom";
  import { toast } from "react-toastify";
  import {
    Container,
    Box,
    TextField,
    Button,
    Typography,
    Paper,
  } from "@mui/material";
  import { useResetPasswordMutation } from "../store/services/userApi";

  const ResetPassword = () => {
    const navigate = useNavigate(); 
    const [searchParams] = useSearchParams();
const token = searchParams.get("keys_value");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [resetPassword, { isLoading }] = useResetPasswordMutation();

    const handleSubmit = async (e) => {
      e.preventDefault();

      if (!token) {
        toast.error("Invalid or expired reset link");
        return;
      }

      if (password !== confirmPassword) {
        toast.error("Passwords do not match");
        return;
      }

      try {
        const result = await resetPassword({ password, token }).unwrap();
        // unwrap() will throw error if the response is not ok
        toast.success(result.message || "Password updated successfully");
        setTimeout(() => navigate("/login"), 1500);
      } catch (err) {
        // err.data.message contains server error if available
        toast.error(err?.data?.message || "Reset failed. Try again.");
      }
    };

    return (
      <Container component="main" maxWidth="xs">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="100vh"
        >
          <Paper elevation={3} sx={{ p: 4, borderRadius: 2, width: "100%" }}>
            <Typography variant="h5" align="center" gutterBottom>
              Reset Password
            </Typography>

            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                type="password"
                label="New Password"
                variant="outlined"
                margin="normal"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <TextField
                fullWidth
                type="password"
                label="Confirm Password"
                variant="outlined"
                margin="normal"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
                disabled={isLoading}
              >
                {isLoading ? "Resetting..." : "Reset Password"}
              </Button>
            </form>
          </Paper>
        </Box>
      </Container>
    );
  };

  export default ResetPassword;
